// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Drawer Layout */
.rag-offcanvas {
    width: 600px !important;
    background: #fff;
    border-left: 1px solid #dee2e6;
}

/* Header */
.rag-header {
    border-bottom: 2px solid #E4E4E4;
    padding: 1rem 1.5rem;
}

.rag-title {
    font-size: 1rem;
    font-weight: 600;
    color: #0066CC;
    margin: 0;
}

.rag-subtitle {
    color: #838FB4;
    font-size: .875rem;
    margin: 0;
}

/* Sections */
.rag-body {
    padding: 1.5rem;
    padding-top: 0px;
    overflow-y: auto;
}

.rag-section {
    margin-bottom: 1.5rem;
}

.rightmodel-title {
    font-weight: 400;
    font-size: .875rem;
    color: #838FB4;
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: "Unilever Desire";
}

/* Grid Styling */
.rightmodel-details-grid,
.rightmodel-info-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;
}

.rightmodel-detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.rightmodel-label {
    font-size: 0.85rem;
    color: #5B5B5B;
    width: 30%;
    font-weight: 400;
}

.rightmodel-value {
    font-size: .875rem;
    color: #111111;
    word-break: break-word;
    text-align: left;
    width: 70%;
}

.url-link {
    color: #0d6efd;
    text-decoration: none;
}

.url-link:hover {
    text-decoration: underline;
}

/* Status Badge */
.rightmodel-status {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 500;
    text-transform: capitalize;
    width: fit-content;
}

.rightmodel-status.completed {
    background-color: rgba(0, 134, 81, 0.15);
    color: #008651;
    border: 1px solid #008651;
}

.rightmodel-status.inprogress {
    background-color: #fff4e5;
    color: #b26a00;
}

.rightmodel-status.failed {
    background-color: #fde8e8;
    color: #a61b1b;
}

/* Tabs */
.rag-tabs {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 1rem;
}

.rag-tabs .nav-link {
    color: #6c757d;
    border: none;
    border-bottom: 2px solid transparent;
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
}

.rag-tabs .nav-link.active {
    color: #0d6efd;
    border-bottom: 2px solid #0d6efd;
    background-color: transparent;
    font-weight: 500;
}

.tab-content-area {
    margin-top: 1rem;
}

.rag_switch {
    display: flex;
    align-items: center;
}

.rag_switch input {
    height: 20px;
    width: 33px;
}

.rag_switch label {
    padding-top: 5px;
    padding-left: 10px;
}

/* file tab */

.files-wrapper {
    padding: 10px;
}

.file-tabs {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.file-tab-btn {
    padding: 5px 18px;
    border-radius: 20px;
    background: #f7f7f7;
    border: none;
    font-size: 14px;
    color: #555;
    cursor: pointer;
}

.file-tab-btn.active {
    background: #0d6efd;
    color: white;
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.file-item {
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: 12px;
    gap: 12px;
}

.files-wrapper .success-bg {
    background: #e9f7ef;
}

.files-wrapper .failed-bg {
    background: #fceaea;
}

.file-icon {
    font-size: 26px;
    margin-top: 3px;
}

.success-icon {
    color: #2ecc71;
}

.failed-icon {
    color: #e74c3c;
}

.file-info {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.file-name {
    font-size: 15px;
    font-weight: 600;
    color: #222;
}

.file-layer {
    font-size: 13px;
    color: #777;
}

.no-items {
    padding: 10px;
    color: #555;
}`, "",{"version":3,"sources":["webpack://./src/components/Rag/RightModel.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA,WAAW;AACX;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA,aAAa;AACb;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,iBAAiB;AACjB;;IAEI,aAAa;IACb,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oCAAoC;IACpC,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,aAAa;;AAEb;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf","sourcesContent":["/* Drawer Layout */\n.rag-offcanvas {\n    width: 600px !important;\n    background: #fff;\n    border-left: 1px solid #dee2e6;\n}\n\n/* Header */\n.rag-header {\n    border-bottom: 2px solid #E4E4E4;\n    padding: 1rem 1.5rem;\n}\n\n.rag-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #0066CC;\n    margin: 0;\n}\n\n.rag-subtitle {\n    color: #838FB4;\n    font-size: .875rem;\n    margin: 0;\n}\n\n/* Sections */\n.rag-body {\n    padding: 1.5rem;\n    padding-top: 0px;\n    overflow-y: auto;\n}\n\n.rag-section {\n    margin-bottom: 1.5rem;\n}\n\n.rightmodel-title {\n    font-weight: 400;\n    font-size: .875rem;\n    color: #838FB4;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-family: \"Unilever Desire\";\n}\n\n/* Grid Styling */\n.rightmodel-details-grid,\n.rightmodel-info-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n}\n\n.rightmodel-detail-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.rightmodel-label {\n    font-size: 0.85rem;\n    color: #5B5B5B;\n    width: 30%;\n    font-weight: 400;\n}\n\n.rightmodel-value {\n    font-size: .875rem;\n    color: #111111;\n    word-break: break-word;\n    text-align: left;\n    width: 70%;\n}\n\n.url-link {\n    color: #0d6efd;\n    text-decoration: none;\n}\n\n.url-link:hover {\n    text-decoration: underline;\n}\n\n/* Status Badge */\n.rightmodel-status {\n    display: inline-block;\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    text-transform: capitalize;\n    width: fit-content;\n}\n\n.rightmodel-status.completed {\n    background-color: rgba(0, 134, 81, 0.15);\n    color: #008651;\n    border: 1px solid #008651;\n}\n\n.rightmodel-status.inprogress {\n    background-color: #fff4e5;\n    color: #b26a00;\n}\n\n.rightmodel-status.failed {\n    background-color: #fde8e8;\n    color: #a61b1b;\n}\n\n/* Tabs */\n.rag-tabs {\n    border-bottom: 1px solid #dee2e6;\n    margin-bottom: 1rem;\n}\n\n.rag-tabs .nav-link {\n    color: #6c757d;\n    border: none;\n    border-bottom: 2px solid transparent;\n    font-size: 0.9rem;\n    padding: 0.5rem 1rem;\n}\n\n.rag-tabs .nav-link.active {\n    color: #0d6efd;\n    border-bottom: 2px solid #0d6efd;\n    background-color: transparent;\n    font-weight: 500;\n}\n\n.tab-content-area {\n    margin-top: 1rem;\n}\n\n.rag_switch {\n    display: flex;\n    align-items: center;\n}\n\n.rag_switch input {\n    height: 20px;\n    width: 33px;\n}\n\n.rag_switch label {\n    padding-top: 5px;\n    padding-left: 10px;\n}\n\n/* file tab */\n\n.files-wrapper {\n    padding: 10px;\n}\n\n.file-tabs {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.file-tab-btn {\n    padding: 5px 18px;\n    border-radius: 20px;\n    background: #f7f7f7;\n    border: none;\n    font-size: 14px;\n    color: #555;\n    cursor: pointer;\n}\n\n.file-tab-btn.active {\n    background: #0d6efd;\n    color: white;\n}\n\n.file-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.file-item {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    border-radius: 12px;\n    gap: 12px;\n}\n\n.files-wrapper .success-bg {\n    background: #e9f7ef;\n}\n\n.files-wrapper .failed-bg {\n    background: #fceaea;\n}\n\n.file-icon {\n    font-size: 26px;\n    margin-top: 3px;\n}\n\n.success-icon {\n    color: #2ecc71;\n}\n\n.failed-icon {\n    color: #e74c3c;\n}\n\n.file-info {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.2;\n}\n\n.file-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: #222;\n}\n\n.file-layer {\n    font-size: 13px;\n    color: #777;\n}\n\n.no-items {\n    padding: 10px;\n    color: #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
